import {SOPostRelationship} from '../../core/relationship/so-post-relationship';
import {RelationshipCore} from './relationship.core';
import {SOGetRelationship} from '../../core/relationship/so-get-relationship';
import {FormField, SelectionOption} from 'lionheartland';
import {postRelationshipFormFieldOptions} from './post-relationship-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePost} from 'lionheartland';
import {ProjectCore} from '../project/project.core';
import {SOGetProject} from '../../core/project/so-get-project';
import {OrganizationCore} from '../organization/organization.core';
import {SOGetOrganization} from '../../core/organization/so-get-organization';

export class RAPostRelationship extends BasePost implements AdapterProtocol {
  formFieldOptions = Object.values(postRelationshipFormFieldOptions);

  RequestClass = SOPostRelationship

  constructor(
    public entityCore: RelationshipCore
  ) {
    super();
    if (postRelationshipFormFieldOptions.project) {
      postRelationshipFormFieldOptions.project.makeCore = true;
    }
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.getFormValueFromIdentifier('name'),
      this.getFormValueFromIdentifier(
        'project',
        SOGetProject,
      ),
      this.getFormValueFromIdentifier(
        'organization',
        SOGetOrganization,
        true,
      ),
      this.getFormValueFromIdentifier('description'),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}